var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyS(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4121 1.68942L14.4335 1.71647L14.4584 1.74033C16.0431 3.25878 16.0672 5.87353 14.4416 7.58689L13.7872 8.27655L8.09256 14.2786L2.24164 8.27414L1.59797 7.59572C0.123382 5.8771 0.147448 3.24345 1.58959 1.72345L1.60511 1.7071L1.61909 1.68942C2.31962 0.803402 3.30228 0.5 4.17137 0.5C5.21554 0.5 6.19229 0.810456 6.88724 1.68942L6.91855 1.72902L6.95714 1.76156L7.77506 2.45122L8.13555 2.75517L8.46009 2.41311L9.11442 1.72345L9.12994 1.7071L9.14392 1.68942C9.83887 0.810456 10.8156 0.5 11.8598 0.5C12.8805 0.5 13.7054 0.79559 14.4121 1.68942Z",
    stroke: "#CDCDCD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyS);
export default __webpack_public_path__ + "static/media/empty_s.e149ebbf72cb0db194d917c6d2d7c52a.svg";
export { ForwardRef as ReactComponent };